/*eslint-disable no-script-url*/
import React, { Component } from 'react';
import * as Common from '../components/Common';

var _experienceTypeList = [
  {type: 'FULL_TIME', text: '종일 09:00 ~ 24:00'},
  {type: 'A_TYPE', text: '오전 09:00 ~ 13:00'},
  {type: 'B_TYPE', text: '오후 13:00 ~ 17:00'},
  {type: 'C_TYPE', text: '야간 17:00 ~ 21:00'},
  {type: 'D_TYPE', text: '심야 21:00 ~ 24:00'}
];

class ExperienceTypePop extends Component {
  constructor(props) {
    super(props);

    this.state = {
      style: null,
      experienceType: this.props.experienceType,
      experienceTypeList: []
    };
  }

  componentDidMount() {
    var _newExperienceTypeList = [];

    var _typeMap = this.props.calendarList[this.props.testUsedate];

    for(var idx in _experienceTypeList) {
      var entity = _experienceTypeList[idx];
      if(_typeMap[entity.type] === true) {
        _newExperienceTypeList.push(entity);
      }
    }

    this.setState({
      style: Common.getCenterPosStyle(this.layer),
      experienceTypeList: _newExperienceTypeList
    });
  }

  _doChangeExperienceTypeEvent = (e) => {
    this.setState({ experienceType: e.target.dataset.experiencetype });
    var layerBgTimer = setTimeout(() => {
      this.layerBg.click();

      clearTimeout(layerBgTimer);
    }, 200);
  }

  render() {
    return (
      <div className="layer-pop" id="sellist-pop" style={this.state.style} ref={ref => this.layer = ref}>	
        <div className="bg" data-experiencetype={this.state.experienceType} data-type="experienceType" onClick={this.props.onClick} ref={ref => this.layerBg = ref}></div>
        <ul className="sel-list-pop">
          {this.state.experienceTypeList.map((entity, index) => <li key={index} className={this.state.experienceType === entity.type ? 'active' : ''}><a href={null} data-experiencetype={entity.type} onClick={this._doChangeExperienceTypeEvent.bind(this)}>{entity.text}</a></li>)}
        </ul>
      </div>
    )
  }
}

export default ExperienceTypePop;